import React, { useContext } from "react";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import SelectSearchInputParam from "../../studentSerach/SelectSearchInputParam";
import { FILTER__FORM_FIELDS, IssuanceIDCardContext, PAGE_STATE } from "../contextApi";
import StudentFilterForm from "./StudentFilterForm";
import ATextAreaV2 from "../../../../../../components/ATextAreaV2/ATextAreaV2";
import { getInputParamRegex, getUpdatedInputParamKey, getUpdatedUserInput, multiValuesSearchPasteHandler } from "../../constant/student-search";

const SearchInput = () => {
  const { globalFilter, setGlobalFilter, getApplications, setCurrentPageState, setPage, resetStudentApplications, setFilterForm } = useContext(IssuanceIDCardContext)

  const callBack = () => {
    setCurrentPageState(PAGE_STATE.PRINT_ID_CARD);
    StudentFilterForm(FILTER__FORM_FIELDS)
  }
  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      applyFilterHandler();
    }
  }

  const applyFilterHandler = () => {
    //reset other filter
    setFilterForm(FILTER__FORM_FIELDS)
    setPage(0);
    getApplications(0, { 
      ...FILTER__FORM_FIELDS, 
        ...globalFilter,
    }, callBack);
  }

  let searchParamTitleMap = { psid: 'PSIDs', studentName: 'student name', applicationId: 'application IDs' }


  return (
    <div className="mb-2 position-relative" style={{height : '90px'}}>
      <div className="mb-2">
        <SelectSearchInputParam
          searchInputParam={globalFilter?.typeOfCheckbox}
          setSearchInputParam={(value) => setGlobalFilter(prev => ({ ...prev, 'typeOfCheckbox': value, userInput : '' }))}
        />
      </div>
      {/* <div style={{ width: "40%" }}>
        <AInput
          placeholder={`Search by ${searchParamTitleMap[globalFilter?.typeOfCheckbox]}`}
          style={{ height: "42px" }}
          value={globalFilter?.userInput}
          handler={(value) => setGlobalFilter(prev => ({ ...prev, 'userInput': value }))}
          onKeyDown={(e) => onKeyDown(e)}
          crossIcon={true}
          rightSearchIcon={true}
          crossHandler={async () => {
            setGlobalFilter(prev => ({ ...prev, 'userInput': '' }));
            setPage(0);
            resetStudentApplications();
          }}
          searchIconClickHandler={() => {
            applyFilterHandler();
          }}
        />
      </div> */}
      <ATextAreaV2
      style={{height : '42px', width : '100%', borderRadius : '8px'}}
      containerStyles={{width : '40%'}}
      key={globalFilter?.typeOfCheckbox}
      placeholder={`Search by ${searchParamTitleMap[globalFilter?.typeOfCheckbox]}`}
      initialVal={globalFilter?.userInput}
      regex={getInputParamRegex(globalFilter?.typeOfCheckbox)}
      onInputChange={userInput => setGlobalFilter(prev => ({...prev, userInput})) }
      crossHandler={async () => {
            setGlobalFilter(prev => ({ ...prev, 'userInput': '' }));
            setPage(0);
            resetStudentApplications();
          }}
      searchHandler={applyFilterHandler}
      value={globalFilter?.userInput}
      onPaste={(e) => multiValuesSearchPasteHandler(e, (sanitizedText) => setGlobalFilter(prev => ({...prev, userInput : prev.userInput + sanitizedText})))}
      />
    </div>
  );
};

export default SearchInput;
